import React from "react";
import { Link } from "react-router-dom";
import { formatImageName, formatNumber } from "../../utils/functions";
import Rating from "./Rating";
import { useTranslation } from "react-i18next";

const ShopCard = ({ item, className = "col-md-6 mb-20" }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className="vendors-two-item rounded-12 overflow-hidden border border-neutral-50 hover-border-main-two-600 transition-2">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="vendors-two-item__top bg-overlay style-two position-relative">
              <div className="vendors-two-item__thumbs">
                <img
                  src={formatImageName(item?.banner) || "/assets/images/banner.png"}
                  alt={item.shopName}
                  className="cover-img"
                />
              </div>
              <div className="customAbsoluteDiv position-absolute bottom-0 inset-inline-start-0 w-100 h-100 p-10 z-1 d-flex align-items-end">
                <div className="">
                  <span className="w-60 h-60 flex-center  rounded-circle flex-shrink-0 mb-4">
                    <img
                      src={formatImageName(item?.logo) || "/assets/images/cover.png"}
                      className="w-60 h-60 cover rounded-circle"
                      alt={item.shopName}
                    />
                  </span>
                  <h6 className="text-white fw-semibold mb-6">
                    <Link to={`/shops/${item.slug}`} className="">
                      {item.shopName}
                    </Link>
                  </h6>
                  <div className="flex-align align-items-center gap-6">
                    <div className="flex-align gap-2">
                      <Rating readonly />
                    </div>
                    <span className="text-md mt-1 fw-medium text-white">{item.rating}</span>
                    <span className="text-md mt-1 fw-medium text-white">
                      ({formatNumber(item.ratingCount)})
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="vendors-two-item__content flex-grow-1">
              <div className="d-flex flex-column gap-14">
                <div className="flex-align gap-8">
                  <div className="location-box bg-white flex-align gap-8 rounded-pill ">
                    <div className="line-height-1">
                      <span className="text-gray-600 text-xs">{t("shopLocation")}</span>
                      <div className="line-height-1">
                        <h6 className="mb-0 text-16">
                          <i className="ph ph-map-pin" /> {item?.country?.name || t("defaultCountry")}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-align gap-8">
                  <span className="flex-center text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph ph-envelope-simple" />
                  </span>
                  <a href={`mailto:${item.shopEmail}`} className="text-md text-gray-900 hover-text-main-60">
                    {item.shopEmail}
                  </a>
                </div>
                <div className="flex-align gap-8">
                  <span className="flex-center text-main-two-600 text-2xl flex-shrink-0">
                    <i className="ph ph-phone" />
                  </span>
                  <a
                    href={`tel:${item.shopPhoneNumber}`}
                    className="text-md text-gray-900 hover-text-main-60"
                  >
                    {item.shopPhoneNumber}
                  </a>
                </div>
              </div>
              <Link
                to={`/shops/${item.slug}`}
                className="btn bg-neutral-600 hover-bg-neutral-700 text-white py-12 px-24 rounded-8 flex-center gap-8 fw-medium mt-24"
              >
                {t("visitStore")}
                <span className="text-xl d-flex text-main-two-600">
                  {" "}
                  <i className="ph ph-storefront" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopCard;
